import { render, staticRenderFns } from "./ArticlesPage.vue?vue&type=template&id=1db17e6a&scoped=true&"
import script from "./ArticlesPage.vue?vue&type=script&lang=js&"
export * from "./ArticlesPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesPage.vue?vue&type=style&index=0&id=1db17e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db17e6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticlePreviewCard: require('/app/components/article/ArticlePreviewCard.vue').default,Skeleton: require('/app/components/Skeleton.vue').default})
